module.exports = __webpack_public_path__ + "static/7-649ef41e0bfeb7f2405bdf1b81c22e72.jpeg";